import Component from 'vue-class-component'
import { Vue } from 'vue-property-decorator'

@Component
export default class ClosedDialog extends Vue {
  private dialog = false

  public open() {
    this.dialog = true
  }

  protected close() {
    this.dialog = false
  }
}
